module.exports = __webpack_public_path__ + "img/footer_phone.a8b2e0b9.svg";